module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topicinfobox"
  }, [_c('header', [_vm._m(0), _vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('div', {
    staticClass: "topicbox"
  }, [_c('div', {
    staticClass: "topicupper"
  }, [_c('h2', [_vm._v(_vm._s(_vm.topicinfo.title))]), _vm._v(" "), _c('span', {
    staticClass: "editor"
  }, [_vm._v(_vm._s(_vm.topicinfo.entname))]), _c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.topicinfo.publishdate))])]), _vm._v(" "), _c('div', {
    staticClass: "articlebox"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.topicinfo.content)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "commentlist"
  }, [_c('ul', _vm._l((_vm.commentResult.commentList), function(item) {
    return _c('li', [_c('a', {
      staticClass: "clickjump",
      on: {
        "click": _vm.downLoad
      }
    }, [_c('div', {
      staticClass: "comment-left"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.author))]), _vm._v(" "), _c('div', {
      staticClass: "time"
    }, [_vm._v(_vm._s(item.commenttime))])]), _vm._v(" "), _c('div', {
      staticClass: "comment-right"
    }, [_c('p', {
      domProps: {
        "innerHTML": _vm._s(item.comment)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "commentimg"
    }, [_c('img', {
      attrs: {
        "src": item.image
      }
    })])])])])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.commentResult.totalItems > 3),
      expression: "commentResult.totalItems>3"
    }],
    staticClass: "morecomment"
  }, [_c('a', {
    staticClass: "clickjump",
    on: {
      "click": _vm.downLoad
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "moretext"
  }, [_vm._v("全部评论（139）")])])])]), _vm._v(" "), _c('div', {
    staticClass: "articlelist"
  }, [_c('div', {
    staticClass: "list-tit"
  }, [_vm._v("相关话题")]), _vm._v(" "), _c('ul', _vm._l((_vm.topiclistResult), function(item) {
    return _c('li', [_c('a', {
      staticClass: "clickjump",
      on: {
        "click": _vm.downLoad
      }
    }, [_c('div', {
      staticClass: "article-left"
    }, [_c('img', {
      attrs: {
        "src": item.imgurl
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "article-right"
    }, [_c('h5', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "author-time"
    }, [_c('span', {
      staticClass: "time"
    }, [_vm._v(_vm._s(item.publishdate))]), _vm._v(" "), _c('span', {
      staticClass: "author"
    }, [_vm._v(_vm._s(item.entname))])]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(item.summary))])])])])
  }))])]), _vm._v(" "), _c('DownloadApp'), _vm._v(" "), _c('div', {
    staticClass: "error-tip",
    attrs: {
      "id": "J_ErrorTip"
    }
  }), _vm._v(" "), _c('MenuFooters', {
    attrs: {
      "isHide": _vm.isHide,
      "menuType": _vm.currentMenuType
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "back",
    attrs: {
      "href": "/#/topic"
    }
  }, [_c('div', {
    staticClass: "arrow-left"
  }, [_c('div', {
    staticClass: "arrow"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "mareimg"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/more.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-6b622328"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TopicInfo.vue
// module id = 195
// module chunks = 1